import style from './StaticField.module.css'
import React from "react";

interface StaticFieldInterface {
    label: string;
    value: string;
}

const StaticField: React.FC<StaticFieldInterface> = ({label, value}) => {
    return <div className={style.staticFieldContainer}>
        <span className={style.fieldLabel}>{label}</span>
        <span className={style.fieldValue}>{value}</span>
    </div>
}

export default StaticField;
